export const theme = {
  recentOrderHeaderBackgroundColor: Styles.color.grey.ten,
};
